import apiClient from "@/common/gateway-api";

export const createComponentInstance = (region, data, componentId, user) =>
  new Promise((resolve, reject) => {
    apiClient
      .post(
        `/api/v1/woo/components/${componentId}/instances`,
        { formData: data, user },
        {
          params: { region }
        }
      )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });

export const updateComponentInstance = (region, data, instanceId, user) =>
  new Promise((resolve, reject) => {
    apiClient
      .put(
        `/api/v1/woo/components/instances/${instanceId}`,
        {
          formData: data,
          user
        },
        { params: { region } }
      )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });

export const fetchCategoryInstance = (region, categoryName) =>
  new Promise((resolve, reject) => {
    apiClient
      .get("/api/v1/woo/components/instances/category", {
        params: { region, categoryName }
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const fetchCategoryUrl = (region, categoryName) => {
  return new Promise((resolve, reject) => {
    apiClient
      .get("/api/v1/woo/components/instances/category/url", {
        params: { region, categorySlug: categoryName }
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
